import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { type CreateStatementItemParams } from '@webapp/modules/accounts-payable/business-logic/interfaces/IStatementItemRepository'
import { statementItemRepository } from '@webapp/modules/accounts-payable/data-access/repositories/StatementItemRepository'
import { StatementItem } from '@webapp/modules/accounts-payable/entities/StatementItem'
import { STATEMENT_ITEM_UNMATCHED_BASE_KEY } from '@webapp/modules/accounts-payable/query-configs/statementItemQueries'

export const useMutateCreateStatementItem = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<
    StatementItem,
    RepoError,
    CreateStatementItemParams
  >({
    mutationFn: async (params) =>
      new StatementItem(await statementItemRepository.create(params)),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: STATEMENT_ITEM_UNMATCHED_BASE_KEY,
      })
    },
  })

  return {
    createStatementItem: mutation.mutateAsync,
    isCreating: mutation.isLoading,
    error: mutation.error,
  }
}
